import request from '@/utils/request'

let InvitationGiftApi = {
  /*添加邀请有礼*/
  addInvitation(data) {
    return request._post('/shop/plus.invitationgift.invitation/add', data);
  },
  /*编辑邀请有礼*/
  editInvitation(data) {
    return request._post('/shop/plus.invitationgift.invitation/edit', data);
  },
  /*列表*/
  InvitationList(data) {
    return request._post('/shop/plus.invitationgift.invitation/lists', data);
  },
  /*发布*/
  send(data) {
    return request._post('/shop/plus.invitationgift.invitation/send', data);
  },
  /*终止*/
  end(data) {
    return request._post('/shop/plus.invitationgift.invitation/end', data);
  },
  /*删除*/
  del(data) {
    return request._post('/shop/plus.invitationgift.invitation/del', data);
  },
  /*获取数据*/
  getInvitation(data) {
    return request._post('/shop/plus.invitationgift.invitation/getDatas', data);
  },
  /*推广二维码*/
  qrcode(data) {
      return request._post('/shop/plus.invitationgift.invitation/qrcode', data);
  },
  /*推广二维码*/
  partakelist(data) {
      return request._post('/shop/plus.invitationgift.invitation/partakelist', data);
  },
}

export default InvitationGiftApi;



// WEBPACK FOOTER //
// ./src/api/invitationgift.js